import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

// ─────────────────────────────────────────────
// CONSTANTS
// ─────────────────────────────────────────────
const PAGE_W = 595.28;
const MARGIN = 20;
const CONTENT_W = PAGE_W - MARGIN * 2;
const FONT = "courier";

// ─────────────────────────────────────────────
// DRAW HEADER
// ─────────────────────────────────────────────
function drawHeader(doc, y, fromDate, toDate, userName) {
    const cx = PAGE_W / 2;

    doc.setFont(FONT, "bold");
    doc.setFontSize(13);
    const companyLines = doc.splitTextToSize(
        "Chamarajanagar District Co operative Milk Producers Union (CHAMUL),",
        CONTENT_W
    );
    companyLines.forEach((line) => { 
        doc.text(line, cx, y, { align: "center" }); 
        y += 15; 
    });

    doc.setFont(FONT, "normal");
    doc.setFontSize(9);
    doc.text(
        "Kuderu Village, Santhemarahalli Hobli, Chamarajanagar Dist, Karnataka -571316, Mob: 08226 – 234848",
        cx, y, { align: "center" }
    );
    y += 12;
    doc.text("GSTIN: 29AACAC2089A1Z1", cx, y, { align: "center" });
    y += 12;

    doc.setLineWidth(1);
    doc.line(MARGIN, y, PAGE_W - MARGIN, y);

    const titleBoxHeight = 22;
    doc.line(MARGIN, y + titleBoxHeight, PAGE_W - MARGIN, y + titleBoxHeight);

    doc.setFont(FONT, "bold");
    const centerY = y + titleBoxHeight / 2 + 4;

    if (userName) {
        doc.setFontSize(10);
        doc.text(`Agent Name: ${userName}`, MARGIN, centerY, { align: "left" });
    }

    doc.setFontSize(12);
    doc.text(`TURNOVER REPORT (${fromDate} to ${toDate})`, PAGE_W - MARGIN, centerY, { align: "right" });

    y += titleBoxHeight + 10;

    return y;
}

// ─────────────────────────────────────────────
// MAIN EXPORT
// ─────────────────────────────────────────────
export function generateTurnoverPDF(data = [], fromDate, toDate, options = {}) {
    const { download = false, filename = `Turnover_Report_${Date.now()}.pdf`, userName, onStart, onFinish } = options;

    if (!data?.length) return;
    onStart?.();

    const columns = [
        { title: "Sl. No", dataIndex: "sl_no", align: "center" },
        { title: "Product", dataIndex: "PACKET_NAME", align: "left" },
        { title: "Rate", dataIndex: "RATE", align: "right" },
        { title: "Qty", dataIndex: "QTY_PKTS", align: "right" },
        { title: "Amount", dataIndex: "AMOUNT", align: "right" }
    ];

    try {
        const doc = new jsPDF({ unit: "pt", format: "a4", orientation: "portrait" });
        let y = MARGIN;

        y = drawHeader(doc, y, fromDate, toDate, userName);

        const head = [columns.map(col => col.title)];
        const body = data.map((row, index) => 
            columns.map(col => {
                if (col.dataIndex === "sl_no") return String(index + 1);
                const val = row[col.dataIndex];
                return val !== undefined && val !== null ? String(val) : "";
            })
        );

        let totalAmount = 0;
        data.forEach(({ AMOUNT }) => {
            totalAmount += Number(AMOUNT) || 0;
        });

        body.push([
            { content: "Total", colSpan: 4, styles: { fontStyle: "bold", halign: "center" } },
            { content: String(totalAmount.toFixed(2)), styles: { fontStyle: "bold", halign: "right" } }
        ]);

        autoTable(doc, {
            head,
            body,
            startY: y,
            margin: { left: MARGIN, right: MARGIN },
            tableWidth: CONTENT_W,
            styles: {
                font: FONT,
                fontSize: 9,
                cellPadding: 3,
                lineColor: [0, 0, 0],
                lineWidth: 0.3,
                textColor: [0, 0, 0],
            },
            headStyles: {
                fillColor: [220, 220, 220],
                textColor: [0, 0, 0],
                fontStyle: "bold",
                halign: "center",
                valign: "middle",
                minCellHeight: 20,
            },
            columnStyles: columns.reduce((acc, col, idx) => {
                acc[idx] = { halign: col.align || "center" };
                return acc;
            }, {}),
            didParseCell(cellData) {
                if (cellData.section === "body") cellData.cell.styles.fillColor = [255, 255, 255];
            },
            theme: "grid",
        });

        // if (download) {
        //     doc.save(filename);
        // } else {
        //     window.open(URL.createObjectURL(doc.output("blob")));
        // }

        const base64PDF = doc.output("datauristring").split(",")[1];

        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(
                JSON.stringify({
                    type: "download_pdf",
                    fileName: filename ,
                    base64: base64PDF
                })
            );
        }
    } catch (err) {
        console.error("Turnover PDF generation error:", err);
    } finally {
        onFinish?.();
    }
}
